import { storeCreator } from '@/utils/store/store.utils';

interface State {
  setReportKeys: (keys: string[]) => void;
  toggleReportKey: (key: string) => void;
  handleReset: () => void;
  reportKeys: string[];
}

const useStore = storeCreator<State>((set) => ({
  reportKeys: [],
  setReportKeys: (keys: string[]) => set(() => ({ reportKeys: keys })),
  toggleReportKey: (key: string) =>
    set((state) => {
      let keys = [...state.reportKeys];
      if (keys.includes(key)) {
        keys = keys.filter((item) => item !== key);
      } else {
        keys = [...keys, key];
      }
      return { reportKeys: keys };
    }),

  handleReset: () => set(() => ({ reportKeys: [] })),
}));

export default useStore;
